
export default {
  layout: {
    "rows": [
      {
        "fields": [ { "name": "site.instituteName" } ]
      },

      {
        "fields": [ { "name": "site.name" } ]
      },

      {
        "fields": [ { "name": "site.code" } ]
      },

      {
        "fields": [ { "name": "site.coordinators" } ]
      },

      {
        "fields": [ { "name": "site.type" } ]
      },

      {
        "fields": [ { "name": "site.address" } ]
      }
    ]
  }
}
